<div (keyup.enter)="logIn()" class="login-container">
    <div class="login-content">
        <form>
            <h1 class="l bold small-line-height" translate>login.title-paragraph-1</h1>
            <h1 class="l bold small-line-height" translate>login.title-paragraph-2</h1>
            <div class="regist-here">
                <p translate class="xs">login.title-paragraph-3.part-1</p>
                <a class="xs underlined bold orange" href="/register" translate>common.register-here</a>
            </div>
            <app-text-input
                [showInputError]="(authenticationService?.generalLoginError | async) || (emailAddressEmpty | async)"
                [autofocus]="true"
                [disabled]="authenticationService?.loading | async"
                [label]="'common.email-address' | translate"
                [value]="emailAddress | async"
                (onChange)="updateEmailAddress($event)"
                [autocomplete]="true"
                type="email"
            >
            </app-text-input>
            <app-text-input
                class="input-forgot"
                [showInputError]="authenticationService?.generalLoginError | async"
                [disabled]="authenticationService?.loading | async"
                [label]="'common.password' | translate"
                (onChange)="updatePassword($event)"
                [value]="password | async"
                [type]="(showPassword | async) ? 'text' : 'password'"
                [paddingRight]="true"
                [automaticOnChangeTrigger]="true"
                [autocomplete]="true"
            >
                <div
                    class="toggle-password-visibility"
                    [ngClass]="(showPassword | async) ? 'toggle-password-visibility--hide' : 'toggle-password-visibility--show'"
                    (click)="togglePasswordVisibility()"
                    (mousedown)="preventFocus($event)"
                ></div>
            </app-text-input>

            <div class="forgot">
                <p *ngIf="!(authenticationService.loading | async)" [routerLink]="'/reset-password'" class="link xxs bold orange clickable" translate>login.forgot-your-pass</p>
            </div>
        </form>

        <app-button
            (onClick)="logIn()"
            [showButtonSpinner]="authenticationService.loading | async"
            [label]="'common.login' | translate"
            class="login-button"
            [disabled]="!!(userIsBot | async)"
        ></app-button>

        <div class="error-box" *ngIf="authenticationService?.generalLoginError | async">
            <p translate class="xs red">login.errors.wrong-credentials</p>
            <div class="error-options">
                <p class="xs red" translate>login.errors.not-registered</p>

                <a class="xs underlined bold red" [routerLink]="'/register'" translate>common.register-here</a>
            </div>
        </div>
        <div class="error-box" *ngIf="authenticationService?.specificLoginError | async">
            <p translate class="xs red">
                {{ authenticationService?.specificLoginError | async }}
            </p>
        </div>

        <div class="social-login-container" [class.disabled]="!!(userIsBot | async)">
            <p translate class="xs">login.alternative-login</p>
            <div class="buttons-social">
                <div class="google-login-container">
                    <div class="google-sign-in" #googleSignIn></div>
                </div>
            </div>
        </div>
    </div>

    <p class="copyright xxs" translate [translateParams]="{ year: year }">footer.all-rights-reserved</p>
</div>
